module.exports = __webpack_public_path__ + "img/progress_left.87bdc5f9.png";